module.exports = __webpack_public_path__ + "static/media/superai_text_sm.b8ad8002.png";